var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("推荐长宽比：1:1")]),_c('p',[_vm._v("推荐尺寸：1080 * 1080像素")]),_c('p',[_vm._v("最小尺寸：600 * 600像素")]),_c('p',[_vm._v("图中文本内容不超过20%效果更佳")])])
}]

export { render, staticRenderFns }